import { Link } from "react-router";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckIcon, MapPinIcon } from "@heroicons/react/24/outline";
import avatarImg from "@/assets/default_pfp.jpg";

export const ClinicianCard = ({ clinician }) => {
    return (
        <Card className="flex flex-wrap text-sm">
            <img
                src={clinician.profileImageUrl || avatarImg}
                alt={`${clinician.firstName} ${clinician.lastName}`}
                className="aspect-square w-[clamp(4rem,12vw,6rem)] rounded-full object-cover object-center xl:w-[clamp(4rem,12vw,7rem)]"
            />
            <div className="relative flex-1">
                <Badge variant="success" size="lg" className="border-0">
                    <CheckIcon className="mr-1 size-4 stroke-2" />
                    Vetted
                </Badge>
                <p className="mt-2 mb-1 text-xl/5 font-semibold text-darkgreen-300">
                    {clinician.firstName} {clinician.lastName}
                </p>
                <p className="mb-2 text-base/6 font-medium text-darkgreen-500">
                    {clinician.professionTitle}
                </p>
                <div className="mb-3 flex items-center">
                    <MapPinIcon className="mr-1 size-4 stroke-2 text-green-700" />
                    <p className="text-neutral-500">
                        {clinician.distanceMeters != "" ? (
                            <>
                                {(
                                    Number(clinician.distanceMeters) *
                                    0.000621371192
                                ).toFixed(1)}
                                mi &#x2022;
                            </>
                        ) : (
                            ""
                        )}{" "}
                        {clinician.addressTown}, {clinician.addressCounty}
                    </p>
                </div>
                <div className="flex flex-wrap gap-2">
                    <p className="w-full font-medium">Services offered:</p>
                    {clinician.services?.map((service) => (
                        <Badge key={service.serviceGuid} variant="secondary">
                            {service.serviceTitle}
                            {/*  - £
                            {Number(service.appointmentPrice).toFixed(2)} */}
                        </Badge>
                    ))}
                </div>
            </div>
            <div className="ms-auto mt-auto w-full md:w-auto">
                <Button variant="primary" asChild className="ms-auto">
                    <Link
                        to={`/clinicians/view/${clinician.firstName}-${clinician.lastName}/${clinician.userID}`}
                        state={{ params: location.search }}
                    >
                        View Profile
                    </Link>
                </Button>
            </div>
        </Card>
    );
};
